var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3264 1.36949C9.93211 0.406588 9.40781 0.197266 9.45425 0.197266C8.29418 0.197266 7.9474 0.406588 7.37666 1.36949L1.46487 6.49204C1.39882 6.55583 1.35032 6.63658 1.32865 6.91169L1.14597 9.57612C0.712489 10.231 1.21819 9.92699 0.724854 10.0506C0.853864 10.1752 1.04069 10.225 1.21718 10.1822L4.17306 9.46947C4.26388 9.44754 4.34748 9.40168 4.41354 9.33789L10.3264 3.63223C10.7196 3.25245 11.7249 3.02418 11.7249 2.20979C11.7249 1.67152 10.7196 1.16615 10.3253 1.35953L10.3264 1.36949ZM4.24015 7.36623L8.11151 3.63023L8.48821 3.99208L4.36607 7.97029L4.24015 7.36623ZM3.50737 6.65849L2.8809 6.5379L7.00408 2.55967L7.37978 2.9225L3.50737 6.65849ZM2.21418 7.42903L3.23801 7.62738L3.44236 8.61522L1.80444 9.00995L2.21418 7.42903ZM7.73686 1.85294L8.10943 1.4931C8.50575 1.11133 9.19727 1.11133 9.59359 1.4931H9.59255C9.98887 1.87488 9.98887 2.54173 9.59255 2.9255L9.21998 3.28535L7.73686 1.85294Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f963908f3e53a24300b38662d5c2cee9.svg";
export { ForwardRef as ReactComponent };